//@ts-nocheck
import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import MDButton from "components/MDButton";

export default function ConfirmDialog({ title, body, open, onClose, onConfirm }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="error">
          Cancel
        </MDButton>
        <MDButton
          onClick={() => {
            onConfirm();
            onClose();
          }}
          color="primary"
        >
          Yes, proceed
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
